var __jsx = React.createElement;
import React, { useEffect, useState } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

import Image from '../../atoms/Image';
import { ImageContainer, LightboxContainer, StyledIconBox, StyledTypography } from './style';
// import zIndex from '@material-ui/core/styles/zIndex';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ImageLightbox = function ImageLightbox(_ref) {
  var images = _ref.images,
    thmubsSize = _ref.thmubsSize,
    searchIcon = _ref.searchIcon;
  var _useState = useState(false),
    isOpen = _useState[0],
    setOpen = _useState[1];
  var _useState2 = useState(0),
    imageIndex = _useState2[0],
    setIndex = _useState2[1];
  var _useState3 = useState(),
    imagesPreview = _useState3[0],
    setImagesPreview = _useState3[1];
  useEffect(function () {
    setImagesPreview(images.slice(0, 6));
  }, []);
  return /*#__PURE__*/_jsxs(LightboxContainer, {
    children: [imagesPreview && imagesPreview.map(function (img, index) {
      return /*#__PURE__*/_jsxs(ImageContainer, {
        children: [/*#__PURE__*/_jsx(Image, {
          fitCover: true,
          onClick: function onClick() {
            setIndex(index);
            setOpen(true);
          },
          src: img
        }), index === 5 && /*#__PURE__*/_jsxs(StyledTypography, {
          onClick: function onClick() {
            setIndex(index);
            setOpen(true);
          },
          variant: "h4",
          children: ["+", images.length - 6]
        }), /*#__PURE__*/_jsx(StyledIconBox, {
          children: searchIcon
        })]
      }, img);
    }), isOpen && /*#__PURE__*/_jsx(Lightbox, {
      mainSrc: images[imageIndex],
      nextSrc: images[(imageIndex + 1) % images.length],
      prevSrc: images[(imageIndex + images.length - 1) % images.length],
      onCloseRequest: function onCloseRequest() {
        return setOpen(false);
      },
      onMovePrevRequest: function onMovePrevRequest() {
        return setIndex((imageIndex + images.length - 1) % images.length);
      },
      onMoveNextRequest: function onMoveNextRequest() {
        return setIndex((imageIndex + 1) % images.length);
      },
      reactModalStyle: {
        overlay: {
          zIndex: 1200
        }
      }
    })]
  });
};
ImageLightbox.defaultProps = {
  thmubsSize: '200px',
  searchIcon: null
};
export default ImageLightbox;